import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sgxnio4cg9: FaireBrandEntity = {
  token: "b_sgxnio4cg9",
  type: "brand",
  name: "Lindo",
  avatarUrl:
    "https://cdn.faire.com/fastly/b8f9a65fb9e7b781271c83c24d94df20b0283df950f17b29d53518a32e54e5e9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b1425cb921390d143690512fca356e317f0eb9685257c4ebd66b3bb8066cc2d1.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b8f9a65fb9e7b781271c83c24d94df20b0283df950f17b29d53518a32e54e5e9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b1425cb921390d143690512fca356e317f0eb9685257c4ebd66b3bb8066cc2d1.png",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 90,
  isTopShop: true,
  isInsider: true,
  description:
    "We were founded in 2007 under Grace Harvest & Associates and have developed many unique health and beauty products under the Lindo brand name. Our goal is to provide customers with uniquely designed and packaged products using high quality and environmentally friendly materials and practices. \n\nLindo Products has been featured in many major magazines, such as Vogue, Glamour, Allure, and the Ladies Home Journal. We have also received coverage on TV and radio shows in North America and in Europe.\n\nThese products are sold at drug stores, beauty supply stores, gift shops, professional salons, spas, and department stores, as well as online in North America, Europe, Australia, and South America.\n\nWe strive to be an industry innovator and leader in the newest self care trends! ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:28.086Z",
    importedBy: "entity-db-cli",
  },
};
